window.GGiftTheme = (function() {
    function Theme() {
        this.init();
    }

    Theme.prototype.init = function() {
        $(window).on('load', function(){
            $('.preloader').fadeOut('slow');
        });

        $('a[href^="http"]').not('a[href^="{{ shop.url }}"]').attr('target', '_blank');
    };

    return Theme;
})();

$(function() {
    var theme = new window.GGiftTheme();
});



